import React, { useState } from 'react';
import { api } from './api';

// A card the agent proposed in a chat (its propose_card): the title, what is
// wrong, where — and Confirm / Reject. Until a person confirms, no card exists
// Confirm saves a remark document for the turn agents to use as context.

const describePlace = (t) => {
  if (!t) return '';
  const a = t.anchor || {};
  const where = [a.word ? `«${a.stressed || a.word}»` : null, a.quote ? `“${a.quote}”` : null, a.paragraph != null ? `paragraph ${[].concat(a.paragraph).join(', ')}` : null, a.turn ? `turn ${a.turn}` : null].filter(Boolean).join(' · ');
  return `Point ${t.pointNo}${t.pointName ? ` · ${t.pointName}` : ''}${t.field ? ` · ${t.field}` : ''}${where ? ` · ${where}` : ''}`;
};

export default function ProposalBlock({ taskId, message, onOpenCard, onChanged }) {
  const meta = message.meta || {};
  const p = meta.proposal || {};
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const act = async (fn) => { setBusy(true); setError(null); try { await fn(); if (onChanged) onChanged(); } catch (e) { setError(e.message); } finally { setBusy(false); } };
  const confirm = () => act(() => api.proposalConfirm(taskId, message.id));
  const reject = () => {
    const note = window.prompt('Why? (optional)');
    if (note === null) return;
    act(() => api.proposalReject(taskId, message.id, note));
  };
  return (
    <div className={`tk-proposal st-${meta.status}`}>
      <div className="tk-proposal-head">
        <span className={`tk-chip ${meta.status === 'confirmed' ? 'st-done' : meta.status === 'rejected' ? 'st-dismissed' : 'st-queued'}`}>{meta.status === 'confirmed' ? 'card created' : meta.status === 'rejected' ? 'rejected' : 'proposed card'}</span>
        <strong>{p.title}</strong>
      </div>
      <div className="tk-proposal-text">{p.summary}</div>
      <div className="tk-muted">{describePlace(p.target)}{p.target && p.target.anchor && p.target.anchor.note ? ` — ${p.target.anchor.note}` : ''}</div>
      {meta.status === 'proposed' ? (
        <div className="tk-accept">
          <button type="button" className="tk-btn tk-btn-primary tk-btn-small" onClick={confirm} disabled={busy}>Confirm</button>
          <button type="button" className="tk-btn tk-btn-ghost tk-btn-small" onClick={reject} disabled={busy}>Reject</button>
          <span className="tk-muted">Confirm saves this remark as a shared document. Work continues in the turn's dialog.</span>
        </div>
      ) : meta.status === 'confirmed' ? (
        <div className="tk-muted">Confirmed by {meta.by}{meta.cardId && onOpenCard ? <> · <button type="button" className="tk-linkbtn" onClick={() => onOpenCard(meta.cardId)}>open the card ↗</button></> : null}</div>
      ) : (
        <div className="tk-muted">Rejected by {meta.by}{meta.note ? `: ${meta.note}` : ''}</div>
      )}
      {error ? <div className="tk-error">{error}</div> : null}
    </div>
  );
}
